export const doubleArrows = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <mask id="a" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha">
    <path fill="#d9d9d9" d="M0 0h20v20H0z"/>
  </mask>
  <g mask="url(#a)">
    <path fill="#fff" d="M7.937 10.001 4.521 6.585a.73.73 0 0 1 0-1.063.73.73 0 0 1 1.062 0L9.541 9.48q.105.105.157.24a.78.78 0 0 1 0 .563.7.7 0 0 1-.157.24L5.583 14.48a.68.68 0 0 1-.52.22.76.76 0 0 1-.521-.24.73.73 0 0 1 0-1.063zm5.938 0-3.417-3.416a.73.73 0 0 1 0-1.063.73.73 0 0 1 1.063 0l3.958 3.958q.105.105.156.24a.78.78 0 0 1 0 .563.7.7 0 0 1-.156.24l-3.958 3.957a.68.68 0 0 1-.521.22.76.76 0 0 1-.521-.24.73.73 0 0 1 0-1.063z"/>
  </g>
</svg>
`;
